import { Box, Button, Paper, Table, TableBody, TableContainer, TableHead, Typography, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React from "react";

type Props = {
  searchLen: number;
  tableHeadElement: () => JSX.Element;
  tableBodyElement: () => JSX.Element;
  isAllLoaded: boolean;
  isLoading: boolean;
  toggleVisibleColumns?: string[];
  handleVisibleColumn?: (index: number) => void;
  invisibleColumnIndices?: number[];
  storeUpdated?: string;
  storehouseUpdated?: string;
  isProductStockList?: boolean;
  supplierCd?: string; // 仕入先・外部倉庫コードをユーザーに分かるよう表示するため
  isSupplier?: boolean; // 仕入先・外部倉庫、商品部在庫更新以外はundefined
};

/**
 * @param root0   コンポーネントのプロップス
 * @returns JSX.Element
 */
function StockTable({
  searchLen,
  tableHeadElement,
  tableBodyElement,
  isAllLoaded,
  isLoading,
  toggleVisibleColumns,
  handleVisibleColumn,
  invisibleColumnIndices,
  storeUpdated,
  storehouseUpdated,
  isProductStockList,
  supplierCd,
  isSupplier,
}: Props) {
  return (
    <>
      <Box mt={3} display="flex" flexDirection="row" borderBottom={4} borderColor="primary.main" justifyContent="flex-start">
        <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
          <Box display="flex" flexDirection="row">
            <Box textAlign="left" display="flex" flexDirection="row" alignItems="flex-end">
              <Typography fontSize={20}>検索結果</Typography>
              <Typography fontSize={20}>&emsp;{searchLen}件</Typography>
            </Box>
            { handleVisibleColumn && invisibleColumnIndices && toggleVisibleColumns &&
              invisibleColumnIndices.map((colIdx, index) =>
                <Box p={1} key={colIdx}>
                  <Button variant="custom-outlined" onClick={() => handleVisibleColumn(index)}>
                    <Box position="absolute" top={0} left={4} height="100%" alignContent="center">
                      <Box height={20}>
                        <AddIcon sx={{fontSize: 20}} />
                      </Box>
                    </Box>
                    {`${'\u00A0'.repeat(2)}${toggleVisibleColumns[colIdx]}`}
                  </Button>
                </Box>
              )
            }
          </Box>
          { storehouseUpdated && storeUpdated &&
            <Box textAlign="left">
              <Typography fontSize={14}>{`店舗更新日時：${storeUpdated}`}</Typography>
              <Typography fontSize={14}>{`自社倉庫更新日時：${storehouseUpdated}`}</Typography>
            </Box>
          }
          { isProductStockList && storehouseUpdated &&
            <Box textAlign="left" alignContent="end" paddingBottom={0.5}>
              <Typography fontSize={14}>{`自社倉庫更新日時：${storehouseUpdated}`}</Typography>
            </Box>
          }
          { supplierCd && isSupplier !== undefined &&
            <Box textAlign="left" alignContent="end" paddingBottom={0.5}>
              <Typography fontSize={14}>{`${isSupplier ? '仕入先' : '外部倉庫'}コード：${supplierCd}`}</Typography>
            </Box>
          }
        </Box>
      </Box>
      <Box mt={2}>
        {/* 表 */}
        <TableContainer component={Paper} sx={{overflowX: "initial", width: "fit-content", minWidth: "100%"}}>
          <Table sx={{width: "100%", borderCollapse: "separate"}} aria-label="order table">
            <TableHead>
              { tableHeadElement() }
            </TableHead>
            <TableBody>
              { tableBodyElement() }
            </TableBody>
          </Table>
        </TableContainer>
        { !isAllLoaded && isLoading &&
          <Box py={3} textAlign="center">
            <CircularProgress />
          </Box>
        }
      </Box>
    </>
  );
}

export default React.memo(StockTable);